import axios from 'axios';

$(document).ready(() => {
  const selector = $('.sortable-slides');

  if (selector.length) {
    selector.sortable({
      helper: 'clone',
      stop() {
        const data = $(this).sortable('serialize');

        axios.post('/admin/api/v1/slide/order', { item: data });
      },
    });
  }
});
